import { createSlice } from '@reduxjs/toolkit';
import errorHandle from './errorHandle';
import { enqueueSnackbar } from './notifierSlice';
import GssVitalSliceService from '../services/GssVitalSliceService';
import { validateText } from '../app/utils';
import { SnackBarType } from '../app/types';
import i18n from '../app/i18n';

export const gssVitalSlice = createSlice({
  name: 'gssVital',
  initialState: {
    data: null,
    isSaved: false,
    isLoading: false,
  },
  reducers: {
    setIsLoading: (state, action) => ({
      ...state,
      isLoading: action.payload,
    }),
    setIsSaved: (state, action) => ({
      ...state,
      isSaved: action.payload,
    }),
    setData: (state, action) => ({
      ...state,
      data: {
        ...state.data,
        ...action.payload,
      },
    }),
    setState: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export const { setIsSaved, setIsLoading, setData, setState } =
  gssVitalSlice.actions;

export const getData = orgId => async dispatch => {
  try {
    dispatch(setIsLoading(true));

    const response = await GssVitalSliceService.getPartnerTagIntegration(orgId);
    dispatch(setData(response));

    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setData(null));
    dispatch(setIsLoading(false));
    dispatch(errorHandle(error));
  }
};

export const saveData = orgId => async (dispatch, getStore) => {
  try {
    dispatch(setIsLoading(true));
    dispatch(setIsSaved(true));

    const { data } = getStore().gssVital;

    const isVerify =
      validateText(data?.apiKey) && validateText(data?.storeName);

    if (isVerify) {
      if (data?.id) {
        await GssVitalSliceService.setPartnerTagIntegration(orgId, data);
      } else {
        await GssVitalSliceService.createPartnerTagIntegration(orgId, data);
      }
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.SUCCESS,
          message: i18n.t(`gssVital:saveSuccess`),
        }),
      );
    } else {
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.ERROR,
          message: i18n.t(`data-error`),
        }),
      );
    }

    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(errorHandle(error));
  }
};

export default gssVitalSlice.reducer;
